// LIBRERIE/IMPORTS
import React from "react";

interface SubHeaderProps {
  title: string;
  isSeo: boolean;
  bg?: string;
}

const SubHeaderDefault: React.FC<SubHeaderProps> = ({ title, isSeo, bg }) => {
  return (
    <div id="subHeader_default" className="bg-overlay-black-20" style={bg ? { backgroundImage: `url(${bg})` } : {}}>
      <div className="container">
        <div className="row align-items-center justify-content-center text-center">
          {isSeo ? (
            <h1>{title}</h1>
          ) : (
            <h2 className="asH1Title">{title}</h2>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubHeaderDefault;